import React, { useState, useRef } from 'react';
import './Login.css';
import { SESSION_NOTICE_KEY } from '../utils/session';

const COMPANY_NAMES = {
  'alessa.ai-matcher.ru': 'Алесса',
  'bezopasno.ai-matcher.ru': 'Безопасно.by',
  'matcher.ipk-service.ru': 'ИПК',
};

function Login({ onLogin }) {
  const [sessionNotice] = useState(() => sessionStorage.getItem(SESSION_NOTICE_KEY));
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const submittingRef = useRef(false);
  const companyName = COMPANY_NAMES[window.location.hostname];
  const API_URL = process.env.REACT_APP_API_URL || '';

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (submittingRef.current) return;
    const login = email.trim();
    if (!login || !password) {
      setError('Введите логин и пароль');
      return;
    }
    submittingRef.current = true;
    setLoading(true);
    setError('');
    try {
      const response = await fetch(`${API_URL}/api/auth/login`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: login, password }),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        if (response.status === 401) {
          setError('Неверный логин или пароль. Проверьте данные и введите пароль заново.');
        } else if (response.status === 429) {
          setError('Слишком много попыток входа. Подождите минуту и повторите попытку.');
        } else {
          setError(typeof data.detail === 'string' ? data.detail : 'Не удалось войти. Повторите попытку позже.');
        }
        return;
      }
      onLogin(data.access_token, data.user_id, data.role, data.company_id, data.onboarding_status, data.ui_profile);
    } catch (_) {
      setError('Не удалось подключиться к серверу. Проверьте соединение и повторите попытку.');
    } finally {
      setLoading(false);
      submittingRef.current = false;
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <header className="login-header">
          <h1>ИИ:Матчер</h1>
          <p>Сопоставление заказов с номенклатурой</p>
          {companyName && <p className="login-company">{companyName}</p>}
        </header>
        {sessionNotice && <div className="login-session-notice" role="status">{sessionNotice}</div>}
        <form onSubmit={handleSubmit} className="login-form" aria-label="Вход в программу">
          <div className="login-field">
            <label htmlFor="login-username">Логин</label>
            <input id="login-username" name="username" type="text" autoComplete="username"
              inputMode="email" autoCapitalize="none" autoCorrect="off" spellCheck={false}
              value={email} onChange={(event) => setEmail(event.target.value)}
              placeholder="Введите логин" required />
          </div>
          <div className="login-field">
            <label htmlFor="login-password">Пароль</label>
            <div className="login-password-field">
              <input id="login-password" name="password" type={showPassword ? 'text' : 'password'}
                autoComplete="current-password" value={password}
                onChange={(event) => setPassword(event.target.value)} placeholder="Введите пароль" required />
              <button type="button" className="login-password-toggle"
                aria-label={showPassword ? 'Скрыть пароль' : 'Показать пароль'}
                aria-pressed={showPassword} onClick={() => setShowPassword(value => !value)}>
                {showPassword ? 'Скрыть' : 'Показать'}
              </button>
            </div>
          </div>
          {error && <div className="login-error" role="alert">{error}</div>}
          <button type="submit" className="login-submit" disabled={loading}>
            {loading ? 'Выполняется вход…' : 'Войти'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
